import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  padding: (p) => p.spacing(1),
};
